import { ISODateTime } from '../../commonv3/types/dates';
import { UserId } from '../../mainv2/types/user';

export type UserTutorialCompletionId = number;
export enum UserTutorialCompletionKey {
  KEY_JOIN_SLACK = 'join_slack', // SHE stationに登録しよう
  KEY_COMPLETE_TUTORIAL_COURSE = 'complete_tutorial_course',
  KEY_START_COURSE = 'start_course',
  KEY_ATTEND_START_DASH = 'attend_start_dash',
  KEY_ATTEND_WELCOME_WORKSHOP = 'attend_welcome_workshop',
}

export type UserTutorialCompletionIndexView = {
  id: UserTutorialCompletionId;
  user_id: UserId;
  tutorial_key: UserTutorialCompletionKey;
  created_at: ISODateTime;
};

export const AllUserTutorialCompletionKeys = [
  UserTutorialCompletionKey.KEY_JOIN_SLACK, // SHE stationに登録しよう
  UserTutorialCompletionKey.KEY_ATTEND_START_DASH,
  UserTutorialCompletionKey.KEY_ATTEND_WELCOME_WORKSHOP,
  UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE,
  UserTutorialCompletionKey.KEY_START_COURSE,
];
